import React, { FC } from "react";

// i18n
import messages from "../PayPalPaymentCard/messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// UI
import { Box } from "@UI/Components/Box/Box";

// hooks
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";

// types
import { IOutlets } from "@Libs/Transclusion/types/outlets";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { ResponsiveFixedButton } from "@UI/Components/ResponsiveFixedButton/ResponsiveFixedButton";
import { PayPalCardIcon } from "@modules/PaymentProcessing/Components/PaymentMethodIcons/Icons/PayPal/PayPal";

type Props = Omit<
  IOutlets["configure-preferred-payment-method.body"]["props"],
  "paymentMethod" | "basket"
> & { children?: React.ReactNode };

export const ConfigurePayPal: FC<Props> = ({ onBack, onSubmit, children }) => {
  const savePayPalMethodMutation = useDataMutation(() =>
    onSubmit(
      {
        provider: "stripe",
        paymentMethod: PaymentMethodType.PAYPAL,
      },
      {
        onError: async (error) => {
          console.error(error);
        },
        onSuccess: async () => {
          console.log("success");
        },
      }
    )
  );

  return (
    <PaymentMethodForm>
      <PaymentMethodForm.Header
        onChangeClick={onBack}
        paymentMethod={PaymentMethodType.PAYPAL}
      >
        <Box display="flex" alignItems="center">
          <FormattedMessage {...messages.paypal} />
          <Box as="span" ml={2} display="inline-flex" alignItems="center">
            <PayPalCardIcon />
          </Box>
        </Box>
      </PaymentMethodForm.Header>

      <PaymentMethodForm.Body>
        <Box>
          <Box mb={5}>{children}</Box>
          <ResponsiveFixedButton
            data-testid="submit-paypal-button"
            isLoading={savePayPalMethodMutation.isLoading}
            h={12}
            width="full"
            colorScheme="seaGreen"
            onClick={() => savePayPalMethodMutation.mutate()}
            isDisabled={savePayPalMethodMutation.isLoading}
          >
            <FormattedMessage {...messages.submit} />
          </ResponsiveFixedButton>
        </Box>
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
